exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.placeholder[data-v-4bed73e5] {\r\n    color: #6c757d;\n}\r\n", ""]);

